import keysCollection from '../../utilities/keysCollection'

export const Keys = keysCollection('SUBCATEGORIES', {
    MODAL_SUBCATEGORIES: 'MODAL_SUBCATEGORIES'
})
